var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"typeTag"},[(_vm.type === 1)?_c('div',{staticClass:"type1"},[_vm._v("违约事实")]):_vm._e(),(_vm.type === 2)?_c('div',{staticClass:"type2"},[_vm._v("高风险人员")]):_vm._e(),(_vm.type === 3)?_c('div',{staticClass:"type3"},[_vm._v("其他")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }